module.exports = __webpack_public_path__ + "img/3.2ca9dcb3.png";